var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckedCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 0H0v16h16V0z",
    fill: "#fff",
    fillOpacity: 0.01
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 14.667c1.841 0 3.508-.746 4.714-1.953A6.646 6.646 0 0014.667 8c0-1.84-.746-3.508-1.953-4.714A6.646 6.646 0 008 1.333c-1.84 0-3.507.747-4.714 1.953A6.646 6.646 0 001.333 8c0 1.84.747 3.508 1.953 4.714A6.646 6.646 0 008 14.667z",
    stroke: "#fff",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.333 8l2 2 4-4",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default __webpack_public_path__ + "static/checked_circle.42c33651.svg";
export { SvgCheckedCircle as ReactComponent };